import { css } from '../../../styled-components';
import { ButtonSize } from '../utils';
import { mgbStyles } from './button.styles.mgb';
const paddingSwitcher = size => {
  switch (size) {
    case ButtonSize.small:
      return `9px 14px`;
    case ButtonSize.normal:
      return `9px 14px`;
    case ButtonSize.large:
      return `14.5px 16px `;
    default:
      throw new RangeError(`Enum ${size} is not defined.`);
  }
};
export const migustoStyles = css`
  ${mgbStyles}

  ${({
  disabled,
  theme: {
    colors
  }
}) => disabled && `background-color: ${colors.tints.gray[45]};
     border-color: ${colors.tints.gray[45]};
     color: #A6A6A6;`}

  border-radius: 999px;
  padding: ${({
  size
}) => paddingSwitcher(size || ButtonSize.normal)};
  font-size: ${({
  theme: {
    fonts: {
      sizes
    }
  }
}) => sizes.text.medium};
  font-family: ${({
  theme: {
    fonts: {
      families
    }
  }
}) => families.condensed};
`;